import { render } from "./PurchaseDetails.vue?vue&type=template&id=3c19acd6&scoped=true"
import script from "./PurchaseDetails.vue?vue&type=script&lang=js"
export * from "./PurchaseDetails.vue?vue&type=script&lang=js"

import "./PurchaseDetails.vue?vue&type=style&index=0&id=3c19acd6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c19acd6"]])

export default __exports__